import { CompassCardUI } from '@scale/compass-ui/types';
import {
  JoinCardShared,
  JoinContextSchemaType,
  type JoinContext,
  JOIN_ADDITIONAL_DATA,
} from '@scale/genai-compass-shared/cards/join_additional_data/card';
import JoinCardComponent from '../JoinCardComponent';
import { faObjectExclude } from '@fortawesome/pro-solid-svg-icons';

const defaultContext: JoinContext = {
  cardType: JOIN_ADDITIONAL_DATA,
  columnsToJoin: [],
};

export const JoinCardInput: CompassCardUI<JoinContextSchemaType> = {
  ...JoinCardShared,
  title: 'Join with Task ID',
  icon: 'object-exclude',
  toolTip: 'Join with Task ID',
  defaultContext,
  legacyComponent: JoinCardComponent,
  button: {
    icon: faObjectExclude,
  },
};
